/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Intro_WhoInputs */



/**
* | output |
* | --- |
* | "Wundo shows the colleagues you have a 1:1 planned with. Someone missing? Plan a 1:1 with that person in your calendar and they appear here on their own. Anyo..." |
*
* @param {Team_Intro_WhoInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_intro_who = /** @type {((inputs?: Team_Intro_WhoInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Intro_WhoInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo toont de collega's met wie je een 1:1 hebt ingepland. Ontbreekt er iemand? Plan een 1:1 met die persoon in je agenda, dan verschijnt die hier vanzelf. Wie je niet wil zien, kun je verbergen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo affiche les collègues avec qui vous avez planifié un one-to-one. Quelqu'un manque ? Planifiez un one-to-one avec cette personne dans votre agenda, et elle apparaîtra ici d'elle-même. Ceux que vous ne voulez pas voir, vous pouvez les masquer.")
	return /** @type {LocalizedString} */ ("Wundo shows the colleagues you have a 1:1 planned with. Someone missing? Plan a 1:1 with that person in your calendar and they appear here on their own. Anyone you don't want to see, you can hide.")
});